/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationItem } from '@squiz/sds';
import {
  ALL_COMPONENTS,
  COMPONENT_DETAILS,
  COMPONENT_DETAILS_WITHIN_SET,
  COMPONENT_SETS,
  COMPONENT_SET_DETAILS,
  CONTENT_MATRIX_IDENTIFIERS,
} from './Screens.constants';

/**
 * All navigation items that make up Component Service screens.
 */
export const DXP_MENU_COMPONENT_SERVICE_SCREENS: Array<NavigationItem> = [
  COMPONENT_SETS,
  ALL_COMPONENTS,
  COMPONENT_SET_DETAILS,
  COMPONENT_DETAILS,
  COMPONENT_DETAILS_WITHIN_SET,
  CONTENT_MATRIX_IDENTIFIERS,
];
